import React from 'react';

const icon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.98 9.87">
      <title>Ida y vuelta</title>
      <path d="M6.7,1.79H2.36L3,1.16H3A.66.66,0,0,0,3.2.67.67.67,0,0,0,2.53,0a.65.65,0,0,0-.44.18h0l0,0,0,0L0,2.54,2.06,4.88h0a.64.64,0,0,0,.46.19.67.67,0,0,0,.67-.67A.63.63,0,0,0,3,3.94l-.64-.65H6.7a.75.75,0,0,0,0-1.5"/>
      <path d="M10,2.54a.78.78,0,1,0-.78.79A.78.78,0,0,0,10,2.54"/>
      <path d="M3.28,8.08H7.62L7,8.71H7a.66.66,0,0,0-.22.48.67.67,0,0,0,.67.67.69.69,0,0,0,.44-.17h0l0,0,0,0L10,7.33,7.92,5h0a.69.69,0,0,0-.47-.2.67.67,0,0,0-.67.67.7.7,0,0,0,.2.48l.64.64H3.28a.75.75,0,1,0,0,1.5"/>
      <path d="M0,7.33a.78.78,0,1,0,.78-.78A.78.78,0,0,0,0,7.33"/>
    </svg>
  )
}

export default icon



// WEBPACK FOOTER //
// ./src/shared/images/svg/idayvuelta.js